export default function FinalCTA() {
  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0 z-0">
            <img
              src="https://public.readdy.ai/ai/img_res/805cd469d0179bae01b12417ebdfcbe0.jpg"
              alt="LELO Premium Experience"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              width="1400"
              height="600"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-fuchsia-900/90 via-pink-900/85 to-fuchsia-900/90"></div>
          </div>

          {/* Content */}
          <div className="relative z-10 py-16 sm:py-20 px-6 sm:px-8 md:px-16 text-center">
            <div className="max-w-3xl mx-auto">
              {/* Icon */}
              <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-white/10 backdrop-blur-sm rounded-full mb-6 sm:mb-8">
                <i className="ri-sparkling-2-fill text-3xl sm:text-4xl text-white"></i>
              </div>

              {/* Headline */}
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 leading-tight px-2">
                Explora el placer premium<br />
                con la garantía LELO
              </h2>

              {/* Description */}
              <p className="text-base sm:text-lg md:text-xl text-white/90 mb-8 sm:mb-10 leading-relaxed px-2">
                Más de 15 años de innovación sueca al servicio de tu bienestar íntimo. 
                Diseño premiado, tecnología única y materiales de la más alta calidad.
              </p>

              {/* Features */}
              <div className="flex flex-wrap justify-center gap-3 sm:gap-4 md:gap-6 mb-8 sm:mb-10 px-2">
                <div className="flex items-center gap-2 text-white">
                  <i className="ri-checkbox-circle-fill text-lg sm:text-xl md:text-2xl text-green-400"></i>
                  <span className="text-xs sm:text-sm font-semibold">Garantía 1 año</span>
                </div>
                <div className="flex items-center gap-2 text-white">
                  <i className="ri-checkbox-circle-fill text-lg sm:text-xl md:text-2xl text-green-400"></i>
                  <span className="text-xs sm:text-sm font-semibold">Envío discreto</span>
                </div>
                <div className="flex items-center gap-2 text-white">
                  <i className="ri-checkbox-circle-fill text-lg sm:text-xl md:text-2xl text-green-400"></i>
                  <span className="text-xs sm:text-sm font-semibold">Devolución fácil</span>
                </div>
                <div className="flex items-center gap-2 text-white">
                  <i className="ri-checkbox-circle-fill text-lg sm:text-xl md:text-2xl text-green-400"></i>
                  <span className="text-xs sm:text-sm font-semibold">Pago seguro</span>
                </div>
              </div>

              {/* CTA Button */}
              <a
                href="https://amzn.to/4pHWB8J"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="whitespace-nowrap inline-flex items-center gap-2 sm:gap-3 bg-white text-fuchsia-600 hover:bg-gray-50 px-6 sm:px-8 md:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold transition-all duration-300 shadow-2xl hover:shadow-white/30 hover:scale-105 cursor-pointer"
              >
                <span>Descubre tu LELO ideal</span>
                <i className="ri-arrow-right-line text-xl sm:text-2xl"></i>
              </a>

              {/* Trust Note */}
              <p className="text-white/70 text-xs sm:text-sm mt-6 sm:mt-8 px-2">
                <i className="ri-lock-line mr-1"></i>
                Compra 100% segura • Más de 10 millones de clientas satisfechas
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
